import { Box, MediaBox, Picture } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet-async"

import { AuthenticateContent, AuthenticateModalTitle } from "./components"
import LoginForm from "./login-form"

const Login = ({ setModalContent }) => {
  const content = (
    <AuthenticateContent>
      <MediaBox greaterThanOrEqual="tablet">
        <Picture
          alt="Signin"
          fallback={require("images/account/register_modal_desktop.jpg")}
          srcSet={[
            {
              height: "701",
              media: "(max-width: 1023px)",
              srcSet: `
              ${require("images/account/register_modal_tablet.jpg")} 283w,
              ${require("images/account/register_modal_tablet_2x.jpg")} 566w
            `,
              width: "283",
            },
            {
              height: "580",
              media: "(min-width: 1024px)",
              srcSet: `
            ${require("images/account/register_modal_desktop.jpg")} 482w,
            ${require("images/account/register_modal_desktop_2x.jpg")} 964w
            `,
              width: "482",
            },
          ]}
          width={{ desktop: "482px", tablet: "283px" }}
        />
      </MediaBox>
      <Box
        flex="1"
        m="auto"
        maxWidth={{ _: "375px", tablet: "none" }}
        px={{ _: 3, desktop: 3, tablet: 2 }}
      >
        <AuthenticateModalTitle>Sign in to your account</AuthenticateModalTitle>
        <LoginForm setModalContent={setModalContent} />
      </Box>
    </AuthenticateContent>
  )
  if (setModalContent) {
    return content
  } else {
    return (
      <Box contain mb={8}>
        <Helmet>
          <title>Signin</title>
        </Helmet>
        <Box maxWidth={{ desktop: "855px", tablet: "640px" }} mx="auto" my={3}>
          {content}
        </Box>
      </Box>
    )
  }
}

Login.propTypes = {
  setModalContent: PropTypes.func,
}

export default Login
